/**
 * L2: the item row (avatar, title, sub-line, wallet tag). It copies the 1Password iOS list row,
 * which the Mac Quick Search row was also taken from (01 §4 rule 6), so phone and Mac read alike.
 * The row never shows a secret value.
 */
import type { AppActions, VaultItem, Wallet } from "../contract.js";
import { avatar, h, icon } from "../shell/dom.js";
import { rowSubtitle } from "../vm/items.js";

export function itemRow(item: VaultItem, wallets: Wallet[], actions: AppActions, opts: { showWallet: boolean; favorite?: boolean }): HTMLElement {
  const wallet = wallets.find((w) => w.id === item.wallet);
  return h(
    "button",
    { class: "row", onclick: () => actions.navigate({ name: "item", itemId: item.id }), "data-item": item.id },
    avatar(item.title),
    h("span", { class: "row-text" }, h("div", { class: "row-title" }, item.title), h("div", { class: "row-sub" }, rowSubtitle(item))),
    h(
      "span",
      { class: "row-accessory" },
      opts.favorite ? h("span", { class: "star", "aria-label": "Favorite" }, icon("star", "icon small fill")) : null,
      opts.showWallet && wallet ? h("span", { class: "wallet-tag" }, wallet.name) : null,
    ),
  );
}
